import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ShopAvailableCoupon from '../../sections/shop/ShopAvailableCoupon';
import CouponProp from '../../sections/shop/propTypes/couponProp';
import translate from '../translate';
import { compose } from '../../services/utilityFunctions';
import withCSRF from '../withCSRF';

const PaymentCouponSection = ({
    t,
    coupons,
    selectedCoupon,
    couponInserted,
    updateCoupon,
    orderAlreadyCreated,
    inputInsertClass,
    wrapperClass,
    showTitle,
    couponContainerClass,
    couponListClass,
}) => {
  const [allCouponsOpen, setAllCouponsOpen] = useState(false);
  const [isViewInMobile, setViewInMobile] = useState(false);
  useEffect(() => setViewInMobile(window.innerWidth < 500), []);
  const activeCoupon = coupons.find(c => c.code === selectedCoupon);
  // the 6 blocks shown
  const isDropdownNeeded = isViewInMobile ? coupons?.length > 2 : coupons?.length > 3;
  const [couponCode, setCouponCode] = useState(couponInserted);
  useEffect(() => setCouponCode(couponInserted), [couponInserted]);
  const handleCouponUpdate = (type, value) => {
    updateCoupon(type, value);
  };
  const handleCouponClick = coupon => {
    setAllCouponsOpen(false);
    handleCouponUpdate('couponSelection', coupon.code);
  };
  const handleCouponCheck = () => {
    handleCouponUpdate('couponInserted', couponCode);
  };
  const handleDropdownClick = () => {
    setAllCouponsOpen(prevState => !prevState);
  };

  const handleCouponInserted = event => {
    setCouponCode(event.target.value);
  };
  const existCouponList = coupons && coupons.length > 0;
  const lessCoupons = isViewInMobile ? coupons.slice(0, 2) : coupons.slice(0, 3);
  const couponsShowing = allCouponsOpen ? coupons : lessCoupons;
  return (
    <div className={`col-12 ${wrapperClass}`}>
      <div className="coupons-choose">
        {showTitle && (
          <div className="title">
            <h3>{t('shop.cart.apply_discount')}</h3>
          </div>
        )}
        {existCouponList && (
          <div className="container">
            <div className="row">
              <span className="col-12 remove-padding-col container-hint">{t('shop.cart.choose_coupon_reward')}</span>
              <div className={couponListClass}>
                <div className="coupon-list">
                  {activeCoupon && !allCouponsOpen ? (
                    <ShopAvailableCoupon
                      coupon={activeCoupon}
                      onClick={handleCouponClick}
                      selectedCoupon={selectedCoupon}
                      orderAlreadyCreated={orderAlreadyCreated}
                      couponContainerClass={couponContainerClass}
                    />
                  ) : (
                    couponsShowing.map(coupon => (
                      <ShopAvailableCoupon
                        coupon={coupon}
                        onClick={handleCouponClick}
                        selectedCoupon={selectedCoupon}
                        orderAlreadyCreated={orderAlreadyCreated}
                        couponContainerClass={couponContainerClass}
                      />
                    ))
                  )}
                </div>
                {isDropdownNeeded && (
                  <button type="button" className="remove-style-btn dropdown-btn" onClick={handleDropdownClick}>
                    {allCouponsOpen ? (
                      <i className="la la-angle-up rotate-up" />
                    ) : (
                      <i className="la la-angle-down rotate-down" />
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
         <div className={`check-coupon ${existCouponList ? 'coupon-hint' : ''}`}>
           <p>{t('shop.cart.check_coupon_hint')}</p>
            <div className={`form-group ${inputInsertClass} remove-padding-col`}>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t('shop.cart.check_coupon_placeholder')}
                  value={couponCode}
                  disabled={orderAlreadyCreated}
                  onChange={handleCouponInserted}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-theme btn-dynamic"
                    type="button"
                    disabled={couponCode.length === 0 || orderAlreadyCreated}
                    onClick={handleCouponCheck}
                  >
                    {t('shop.cart.check')}
                  </button>
                </div>
              </div>
            </div>
         </div>
      </div>
    </div>
  );
};

PaymentCouponSection.propTypes = {
  t: PropTypes.func.isRequired,
  coupons: PropTypes.arrayOf(PropTypes.shape(CouponProp.propType)).isRequired,
  couponInserted: PropTypes.string.isRequired,
  selectedCoupon: PropTypes.string,
  updateCoupon: PropTypes.func.isRequired,
  orderAlreadyCreated: PropTypes.string,
  inputInsertClass: PropTypes.string,
  showTitle: PropTypes.bool,
  wrapperClass: PropTypes.string,
  couponContainerClass: PropTypes.string,
  couponListClass: PropTypes.string,
};

PaymentCouponSection.defaultProps = {
  selectedCoupon: null,
  orderAlreadyCreated: null,
  inputInsertClass: 'col-lg-6 col-12',
  showTitle: true,
  wrapperClass: '',
  couponContainerClass: 'col-12 col-lg-4 my-1 my-lg-0',
  couponListClass: '',
};

export default compose(
  translate,
  withCSRF,
)(PaymentCouponSection);
